import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import duration from 'dayjs/plugin/duration'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import minMax from 'dayjs/plugin/minMax'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(duration)
dayjs.extend(minMax)

export const calculatePaymentSchedule = products => {
  if (!products || !products?.length) return
  const paymentSchedule = []

  // Ensure products is an array, or default to an empty array
  const validProducts = Array.isArray(products) ? products.filter(product => product.startDate && product.endDate) : []

  if (validProducts.length === 0) {
    return [] // Return an empty schedule if no valid products exist
  }

  // Determine the earliest start date and latest end date among all valid products
  const start = dayjs.min(validProducts.map(p => dayjs(p.startDate)))
  const end = dayjs.max(validProducts.map(p => dayjs(p.endDate)))

  // Iterate over each month between the start and end date
  for (let current = start.startOf('month'); current.isSameOrBefore(end); current = current.add(1, 'month')) {
    const month = current.format('MM')
    const year = current.format('YYYY')
    let paymentAmount = 0
    let productCount = 0
    let activeDays = 0
    let productsAssociated = []

    validProducts.forEach(product => {
      const productStart = dayjs(product.startDate)
      const productEnd = dayjs(product.endDate)

      // Check if the product is active in the current month
      if (productStart.isSameOrBefore(current.endOf('month')) && productEnd.isSameOrAfter(current.startOf('month'))) {
        productCount += 1
        productsAssociated.push(product.productName)
        // Calculate the overlap days
        const overlapStart = productStart.isBefore(current.startOf('month')) ? current.startOf('month') : productStart
        const overlapEnd = productEnd.isAfter(current.endOf('month')) ? current.endOf('month') : productEnd
        activeDays += overlapEnd.diff(overlapStart, 'days') + 1
        // Set price to 0 if the payer is 'Client', otherwise use the product's price
        const marginNum = parseFloat(product.margin) || 0
        const productPrice =
          product.payer === 'Client' && marginNum === 0
            ? 0
            : product.payer === 'Client' && marginNum > 0
            ? parseFloat(product.grossProfit)
            : parseFloat(product.price)

        // Add product price to the payment amount
        paymentAmount += productPrice
      }
    })

    paymentSchedule.push({
      month,
      year,
      paymentAmount: paymentAmount.toFixed(2), // Convert to 2 decimal places
      productCount,
      activeDays,
      productsAssociated: productsAssociated.join(', '),
    })
  }

  return paymentSchedule
}

// import dayjs from 'dayjs'
// import utc from 'dayjs/plugin/utc'
// import timezone from 'dayjs/plugin/timezone'
// import advancedFormat from 'dayjs/plugin/advancedFormat'
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
// import duration from 'dayjs/plugin/duration'
// import minMax from 'dayjs/plugin/minMax'

// dayjs.extend(utc)
// dayjs.extend(timezone)
// dayjs.extend(advancedFormat)
// dayjs.extend(isSameOrBefore)
// dayjs.extend(isSameOrAfter)
// dayjs.extend(duration)
// dayjs.extend(minMax)

// export const calculatePaymentSchedule = deal => {
//   const paymentSchedule = []
//   const { products } = deal || {} // Ensure deal and products are defined

//   // Ensure products is an array, or default to an empty array
//   const validProducts = Array.isArray(products) ? products.filter(product => product.startDate && product.endDate) : []

//   if (validProducts.length === 0) {
//     return [] // Return an empty schedule if no valid products exist
//   }

//   // Determine the earliest start date and latest end date among all valid products
//   const start = dayjs.min(validProducts.map(p => dayjs(p.startDate)))
//   const end = dayjs.max(validProducts.map(p => dayjs(p.endDate)))

//   // Iterate over each month between the start and end date
//   for (let current = start.startOf('month'); current.isSameOrBefore(end); current = current.add(1, 'month')) {
//     const month = current.format('MM')
//     const year = current.format('YYYY')
//     let paymentAmount = 0
//     let productCount = 0
//     let activeDays = 0
//     let productsAssociated = []

//     validProducts.forEach(product => {
//       const productStart = dayjs(product.startDate)
//       const productEnd = dayjs(product.endDate)

//       // Check if the product is active in the current month
//       if (productStart.isSameOrBefore(current.endOf('month')) && productEnd.isSameOrAfter(current.startOf('month'))) {
//         productCount += 1
//         productsAssociated.push(product.productName)
//         // Calculate the overlap days
//         const overlapStart = productStart.isBefore(current.startOf('month')) ? current.startOf('month') : productStart
//         const overlapEnd = productEnd.isAfter(current.endOf('month')) ? current.endOf('month') : productEnd
//         activeDays += overlapEnd.diff(overlapStart, 'days') + 1
//         // Set price to 0 if the payer is 'Client', otherwise use the product's price
//         const productPrice =
//           product.payer === 'Client' && product.margin === 0
//             ? 0
//             : product.payer === 'Client' && product.margin > 0
//             ? parseFloat(product.grossProfit)
//             : parseFloat(product.price)

//         // Add product price to the payment amount
//         paymentAmount += productPrice
//       }
//     })
//     console.log('activeDays', activeDays)

//     paymentSchedule.push({
//       month,
//       year,
//       paymentAmount: paymentAmount.toFixed(2), // Convert to 2 decimal places
//       productCount,
//       activeDays,
//       productsAssociated: productsAssociated.join(', '),
//     })
//   }

//   return paymentSchedule
// }
